// NPM Imports
import React, { Fragment } from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import { UpgradeBadge } from "../../../commonComponents";

export default function AddOptionToClauseBtnUpgrade(props) {
  return (
    <Fragment>
      <Tooltip
        placement="top"
        overlay="Use this feature to add variation options to this clause in the form mode."
        align={{ offset: [0, 3] }}>
        <span
          className="add-clause-btn add-option-to-this-clause-btn"
          data-test="addoptiontoclausebtn-add-option-to-this-clause-btn"
          onMouseDown={() =>
            props.toggleUpgradePopup("showAddClauseUpgradePopup", true)
          }
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}>
          <i>
            <FontAwesomeIcon icon={["far", "layer-plus"]} />
          </i>
          Add Clause Option &nbsp; <UpgradeBadge />
        </span>
      </Tooltip>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/DocumentItems/AddOptionToClauseBtn/AddOptionToClauseBtnUpgrade.js